import './Footer.css'

function Footer() {

    return (
        <div className="Footer">
            <div id="footer-content">
                <h6>CONTACTO</h6>
                <div id="footer-main">
                    <iframe id="footer-map" title="Mapa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.712515791142!2d-58.36756592334067!3d-34.66196256057809!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a33351e43439b5%3A0x79fc3e9c9f62f309!2s25%20de%20Mayo%2019%2C%20B1870BZA%20Gran%20Buenos%20Aires%2C%20Buenos%20Aires!5e0!3m2!1ses-419!2sar!4v1688160424011!5m2!1ses-419!2sar" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                    <div id="footer-contact">
                        <div className="footer-contact-element"><img src={ process.env.PUBLIC_URL + "/imgs/mail.svg" } alt="" /><a href="mailto:activacionesyventas@gmail.com" target="_blank" rel="noreferrer">activacionesyventas@gmail.com</a></div>
                        <div className="footer-contact-element"><img src={ process.env.PUBLIC_URL + "/imgs/phone.svg" } alt="" /><p>7729-3910</p></div>
                        <div className="footer-contact-element"><img src={ process.env.PUBLIC_URL + "/imgs/pin.svg" } alt="" /><p>25 de Mayo 19, Avellaneda</p></div>
                    </div>
                </div>
            </div>
            <p id="footer-bottom">Agente oficial Claro</p>
        </div>
    );
}

export default Footer;